import {Injectable} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {map, take} from "rxjs/operators";
import {Location} from "@angular/common";
import {firstValueFrom} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UrlService {

    constructor(
        private router: Router,
        private location: Location,
    ) {
    }

    //Set the product name in the url for SEO purposes.
    async setName(name: string, activatedRoute: ActivatedRoute) {
        const nameInUrl = await firstValueFrom(activatedRoute.paramMap.pipe(map(paramsMap => paramsMap.get('name')),take(1)));
        if (nameInUrl != null) {
            return;
        }


        const urlFriendlyName = this.createSeoFriendlySlug(name);
        // It replaces all spaces with dashes.
        this.location.replaceState(`${this.location.path()}/${urlFriendlyName}`);
    }

    createSeoFriendlySlug(name: string): string {
        //It converts the string to a normalized Unicode format and replaces diacritical marks in the given Unicode range by empty strings.
        const normalizedNameWithoutDiacritics = name.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        const seoFriendlyName = normalizedNameWithoutDiacritics
            //It replaces all spaces with dashes.
            .replace(/ /g, '-')
            //It replaces all forward slashes with dashes.
            .replace(/\//g, '-')
            //The following lines of code remove the special characters.
            .replace(/\\/g,'')
            .replace(/\./g,'')
            .replace(/,/g,'')
            .replace(/\(/g,'')
            .replace(/\)/g,'')
            .replace(/®/g,'')
            .replace(/ª/g,'')
            .replace(/º/g,'')
            .replace(/¿/g,'')
            .replace(/\?/g,'')
            .replace(/!/g,'')
            .replace(/¡/g,'')
            .replace(/@/g,'')
            .replace(/"/g,'')
            .replace(/#/g,'')
            .replace(/%/g,'')
            .replace(/¬/g,'')
            .replace(/\[/g,'')
            .replace(/]/g,'')
            .replace(/;/g,'')
            .replace(/;/g,'')
            .replace(/:/g,'')
            .replace(/\^/g,'')
            .replace(/\*/g,'')
            .replace(/{/g,'')
            .replace(/}/g,'')
        return encodeURIComponent(seoFriendlyName);
    }
}
